import React from 'react'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'
import type CustomLinkType from '@atoms/CustomLink/CustomLink.types'

type ServiceCustomLinkProps = {
  wrapperClassname?: string
  iconWrapperClassname?: string
  textClassname?: string
  children?: React.ReactNode
  icon?: React.ReactNode
  url?: string
  noFollow?: boolean
  isExternalLink?: boolean
  uppercase?: boolean
}

const ServiceCustomLink = ({
  wrapperClassname,
  iconWrapperClassname,
  textClassname,
  children,
  icon,
  url,
  noFollow,
  isExternalLink = true,
  uppercase
}: ServiceCustomLinkProps): React.ReactNode => {
  if (url) {
    let customLinkProps: CustomLinkType = {
      href: url,
      className: wrapperClassname,
      colorScheme: 'whiteAlpha',
      isExternalLink: isExternalLink,
      uppercase: uppercase
    }

    if (noFollow) {
      customLinkProps = {
        ...customLinkProps,
        openInNewTab: true,
        rel: 'nofollow'
      }
    }
    return (
      <CustomLinkComponent {...customLinkProps}>
        <div className={iconWrapperClassname}>
          {icon}
          {children && <span className={textClassname}>{children}</span>}
        </div>
      </CustomLinkComponent>
    )
  }

  return (
    <div className={iconWrapperClassname}>
      {icon}
      {children && <span className={textClassname}>{children}</span>}
    </div>
  )
}

export default ServiceCustomLink
